/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
// React
import { useHistory } from "react-router-dom";
import { formatDistanceToNow } from "date-fns";
import { ptBR } from "date-fns/locale";

import {
    IconBell,
    IconEditProfile, IconEyeOpen,
} from "../../icons";
import { IconClock } from "../../icons/IconesSistema";

import {
    Container,
    DivCode,
    DivIcon,
    DivName,
    DivProfile,
    NotificationWrapper, NotificationTop, DivDescricao, DivTimestamp,
    UnreadBadge
} from "./styles";
import api from "../../../services/api";

const formatarDataRelativa = (data: string | Date | null | undefined): string => {
    if (!data) return "";
    try {
        const dataFormatada = new Date(data);
        if (Number.isNaN(dataFormatada.getTime())) return "";
        return formatDistanceToNow(dataFormatada, { 
            addSuffix: true, 
            locale: ptBR 
        });
    } catch (error) {
        return "";
    }
};

export default function NotificationCard({ notification, reload }: any) {
    const history = useHistory();    

    async function visualizaNotificacao()
    {
        await api.post(`/notificacoes/${notification.id}/visualizar`)
        reload()
        window.dispatchEvent(new Event('refreshCounters'));
    }

    function acessarNotificacao()
    {
        history.push(
            {
                pathname: notification.action,
                state: {
                    type: 1
                }
            }
        )
    }

    notification.criado = new Date(notification.criado)


    return (
        <Container>
            <NotificationWrapper
                key={notification.id}
             visualizado={notification.visualizado ?? false}>
                <NotificationTop>
                    <DivIcon visualizado={notification.visualizado ?? false}>
                        <IconBell />
                        {!notification.visualizado && <UnreadBadge />}
                    </DivIcon>

                    <DivCode>
                        <div className="subtitle">N#{notification.id}</div>
                    </DivCode>

                    <DivName visualizado={notification.visualizado ?? false}>
                        <div className="subtitle">{notification.titulo}</div>
                    </DivName>

                    <DivDescricao>
                        <div className="subtitle">{notification.descricao}</div>
                    </DivDescricao>
                    <DivTimestamp>
                        <div className="subtitle">
                            <IconClock size={14} />
                            {formatarDataRelativa(notification.criado)}
                        </div>
                    </DivTimestamp>


                    <DivProfile
                        onClick={() => {
                            visualizaNotificacao().then();
                            acessarNotificacao()
                        }}
                        title="Verificar Notificação"
                    >
                        <IconEditProfile />
                    </DivProfile>
                    <DivProfile
                        onClick={() => {
                            visualizaNotificacao().then();
                        }}
                        title="Marcar como Lida"
                    >
                        <IconEyeOpen color='#ffffff'/>
                    </DivProfile>

                </NotificationTop>

            </NotificationWrapper>

        </Container>
    )
}
